import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from 'theme';

const CarIcon = ({
  size = '32px',
  secondaryColor = COLORS.white,
  primaryColor = COLORS.kinetikBlue,
  sx,
  rotationInDegrees = 0,
  ...props
}) => (
  <SvgIcon
    sx={{
      width: size,
      height: size,
      rotate: `${rotationInDegrees}deg`,
      ...sx,
    }}
    {...props}
  >
    <path
      fill={primaryColor}
      d="M22.5 10.125h-1.012l-2.605-5.86a1.5 1.5 0 0 0-1.37-.89H6.486a1.5 1.5 0 0 0-1.37.89l-2.604 5.86H1.5a.75.75 0 1 0 0 1.5h.75v7.5a1.5 1.5 0 0 0 1.5 1.5H6a1.5 1.5 0 0 0 1.5-1.5v-.75h9v.75a1.5 1.5 0 0 0 1.5 1.5h2.25a1.5 1.5 0 0 0 1.5-1.5v-7.5h.75a.75.75 0 1 0 0-1.5Zm-15 4.5H5.25a.75.75 0 1 1 0-1.5H7.5a.75.75 0 1 1 0 1.5Zm11.25 0H16.5a.75.75 0 1 1 0-1.5h2.25a.75.75 0 1 1 0 1.5Zm-14.596-4.5 2.333-5.25h11.025l2.334 5.25H4.154Z"
    />
    <path
      fill={secondaryColor}
      d="M16 19.125v-.25H8v.25a2 2 0 0 1-2 2H3.75a2 2 0 0 1-2-2v-7H1.5a1.25 1.25 0 0 1 0-2.5v.5a.75.75 0 0 0-.53.22l-.094.114a.75.75 0 0 0 .624 1.166h.75v7.5a1.5 1.5 0 0 0 1.5 1.5H6a1.5 1.5 0 0 0 1.5-1.5v-.75h9v.75a1.5 1.5 0 0 0 1.5 1.5h2.25a1.5 1.5 0 0 0 1.5-1.5v-7.5h.75a.75.75 0 0 0 .624-1.166l-.094-.114a.75.75 0 0 0-.53-.22v-.5a1.25 1.25 0 0 1 0 2.5h-.25v7a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2Zm-8.5-5v.5H5.25v-.5H7.5Zm11.25 0v.5H16.5v-.5h2.25Zm.25-.25a.25.25 0 0 0-.25-.25H16.5a.25.25 0 0 0 0 .5v.5a.75.75 0 0 1-.416-.126l-.114-.094a.75.75 0 0 1-.094-.946l.094-.114a.75.75 0 0 1 .53-.22h2.25a.75.75 0 1 1 0 1.5v-.5a.25.25 0 0 0 .25-.25Zm-11.25 0a.25.25 0 0 0-.25-.25H5.25a.25.25 0 0 0 0 .5v.5a.75.75 0 0 1-.416-.126l-.114-.094a.75.75 0 0 1-.094-.946l.094-.114a.75.75 0 0 1 .53-.22H7.5a.75.75 0 1 1 0 1.5v-.5a.25.25 0 0 0 .25-.25Zm9.763-11a2.001 2.001 0 0 1 1.827 1.188l2.473 5.562h.687v.5h-1.012l-2.605-5.86a1.5 1.5 0 0 0-.464-.585l-.09-.063a1.5 1.5 0 0 0-.708-.238l-.108-.004v-.5Zm-11.026.5a1.5 1.5 0 0 0-1.37.89l-2.604 5.86H1.5v-.5h.688L4.66 4.062l.064-.13a2 2 0 0 1 1.763-1.057v.5Zm13.359 6.75H4.154l2.333-5.25h11.025l2.334 5.25Zm-14.922-.5h14.152l-1.889-4.25H6.813l-1.888 4.25Zm12.589-6.75v.5H6.486v-.5h11.026Z"
    />
    <path
      fill={secondaryColor}
      d="M7.75 14.375h-3v-1h3v1ZM19.25 14.375h-3v-1h3v1ZM19.356 9.842 4.732 9.743 6.728 5.21l10.616-.089 2.012 4.722Z"
    />
  </SvgIcon>
);

CarIcon.propTypes = {
  size: PropTypes.string,
  secondaryColor: PropTypes.string,
  primaryColor: PropTypes.string,
  rotationInDegrees: PropTypes.number,
  sx: PropTypes.object,
};

export default CarIcon;
